import { useContext } from 'react';

import { SnackContext } from 'contexts';

export const useSnackContext = () => useContext(SnackContext);
